import styled from 'styled-components';

export const MapContainerWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 235px;
  position: relative;
`;
